module.exports = __webpack_public_path__ + "static/008635-1c1e4a6b0e1fde972b35bdb15b65a2d7.jpg";